import {Component, OnInit, ViewChild} from '@angular/core';
import {MerchantService} from '../../../shared/services/merchant.service';
import {MerchantContact} from '../../../entities/merchant-contact.model';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MassSmsComponent} from '../../../shared/mass-sms/mass-sms.component';
import {Principal, User} from '../../../shared';
import {Branch, Marketday} from '../../../entities';
import {ApiService} from '../../../shared/services/api.service';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-marketwebsites-sms',
  templateUrl: './marketwebsites-sms.component.html',
  styles: []
})
export class MarketwebsitesSmsComponent implements OnInit {

  @ViewChild('smsModal') private smsModal;
  account: User;
  modalRef: NgbModalRef = null;
  allContacts: MerchantContact[];
  branches: Branch[];
  marketplaces: {id: number, keyword: string, marketdays: Marketday[]}[] = [];
  smsModalTitle = '';

  loading = false;

  selectedRecipientGroupValue: any;
  recipientGroups: {value: string, label: string}[];
  selectedFederalStates: any;
  selectedMarketdateId: any;
  selectedCommune: any;
  selectedBranchId: number;
  federalStates: string[] = [];

  constructor(
    private merchantService: MerchantService,
    public modalService: NgbModal,
    private principal: Principal,
    private apiService: ApiService,
    private jhiLanguageService: JhiLanguageService
  ) {
    this.jhiLanguageService.setLocations(['home']);
    this.recipientGroups = [];
    this.principal.identity().then((account: User) => {
      this.account = account;
      if (account.authorities.some(role => role === 'ROLE_ADMIN')) {
        this.recipientGroups.push(
          { value: 'all', label: 'Alle Beschicker (unternehmensweit)' },
          { value: 'branch', label: 'Alle Beschicker einer bestimmten Niederlassung' }
        );
      }
      this.recipientGroups.push(
        { value: 'federalstate', label: 'Alle Beschicker eines bestimmten Bundeslandes' },
        // { value: 'commune', label: 'Alle Beschicker einer bestimmten Kommune' },
        { value: 'marketdate', label: 'Alle Beschicker eines bestimmten Markttages' }
      );
    });
  }

  ngOnInit() {
    this.apiService.getBranches().then((data) => this.branches = data.filter(b => b.branchNumber !== 10));
  }

  async onClick(state: number) {
    this.loading = true;
    this.allContacts = null;
    switch (state) {
      case 1:
        this.allContacts = await this.merchantService.getContacts();
        this.smsModalTitle = 'Neue SMS-Nachrichten an Beschicker (Basispräsentation, mind. 1 Markt live)';
        break;
      case 2:
        this.allContacts = await this.merchantService.getContactsByAdvertisingPresentation();
        this.smsModalTitle = 'Neue SMS-Nachrichten an Beschicker (Werbepräsentation, mind. 1 Markt live)';
        break;
      case 3:
        this.allContacts = await this.merchantService.getResponsibleContacts();
        this.smsModalTitle = 'Neue SMS-Nachrichten an Verantwortliche §5 DDG (Werbepräsentation, mind. 1 Markt live)';
        break;
      case 4:
        this.allContacts = await this.merchantService.getContactsByTerms();
        this.smsModalTitle = 'Neue SMS-Nachrichten an Beschicker (noch nie Beschickerportal geöffnet)';
        break;
      case 5:
        this.allContacts = await this.merchantService.getContactsByAdvertisingPresentation(false);
        this.smsModalTitle = 'Neue SMS-Nachrichten an Beschicker (Keine Werbepräsentation)';
        break;
      default:
        break;
    }

    if (this.allContacts) {
      this.allContacts.forEach((c) => {
        if (!this.federalStates.some(s => s === c.marketplaceFederalState)) {
          this.federalStates.push(c.marketplaceFederalState);
        }
        if (!this.marketplaces.some((md) => md.id === c.marketplaceId)) {
          this.marketplaces.push({
            id: c.marketplaceId,
            keyword: c.marketplaceTitle,
            marketdays: []
          } as any);
        }
        const market = this.marketplaces.find(m => m.id === c.marketplaceId);
        if (!market.marketdays.some((md) => md.id === c.marketdayId)) {
          market.marketdays.push(new Marketday({
            id: c.marketdayId,
            keyword: c.marketdayTitle
          }));
        }
        this.marketplaces.sort((a, b) => a.keyword > b.keyword ? 1 : a.keyword < b.keyword ? -1 : 0);
      });
    }
    this.loading = false;

    if (this.allContacts) {
      this.modalRef = this.modalService.open(this.smsModal, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
    }
  }

  newMassSms(contacts, recipientType = 'merchantContactPersons', showBranchFilter?, weeks?: number) {
    this.modalRef = this.modalService.open(MassSmsComponent, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
    this.modalRef.componentInstance.contacts = contacts;
    this.modalRef.componentInstance.recipientType = recipientType;
    this.modalRef.componentInstance.showBranchFilter = showBranchFilter;
    if (weeks) { this.modalRef.componentInstance.numberOfWeeks = weeks; }
  }

  onSubmit(): void {
    let contacts: MerchantContact[];
    switch (this.selectedRecipientGroupValue) {
      case 'all':
        this.newMassSms(this.merchantService.merchantContactsToContact(this.allContacts));
        break;
      case 'branch':
        contacts = this.allContacts.filter((c) =>
          c.marketplaceBranchId.toString() === this.selectedBranchId.toString()
          && this.selectedFederalStates.some(state => state === c.marketplaceFederalState));
        break;
      case 'marketdate':
        contacts = this.allContacts.filter((c) => c.marketdayId.toString() === this.selectedMarketdateId.toString());
        break;
      case 'federalstate':
        contacts = this.allContacts.filter((c) => this.selectedFederalStates.some(state => state === c.marketplaceFederalState));
        break;
      default: break;
    }

    if (contacts) {
      this.newMassSms(this.merchantService.merchantContactsToContact(contacts));
    }
  }

  getContactCount() {
    return this.allContacts.length;
  }

  recipientGroupSelected() {
  }

  getContactCountByBranch(branchId: number) {
    return this.allContacts.filter((c) => c.marketplaceBranchId === branchId).length;
  }

  getContactCountByState(state: string) {
    if (this.selectedRecipientGroupValue === 'branch') {
      return  this.allContacts.filter(c => c.marketplaceFederalState === state
        && c.marketplaceBranchId.toString() === this.selectedBranchId.toString()).length;
    }
    return this.allContacts.filter(c => c.marketplaceFederalState === state).length;
  }

  getContactCountByMarketday(marketdayId: number) {
    return this.allContacts.filter(c => c.marketdayId === marketdayId).length;
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/components/marketwebsites-sms/marketwebsites-sms.component.ts